import {Component, Input} from '@angular/core';
import {NgScrollbar} from 'ngx-scrollbar';
import {UtCardComponent, UtCardContentDirective, UtCardTitleDirective} from '../../ui';
import {LanguageSwitchComponent} from '../../language-switch/language-switch.component';

import {S3ImgComponent} from '../../aws/s3-img/s3-img.component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-account-actions',
  templateUrl: './account-actions.component.html',
  styleUrls: ['./account-actions.component.scss'],
  imports: [
    NgScrollbar,
    UtCardComponent,
    UtCardTitleDirective,
    LanguageSwitchComponent,
    S3ImgComponent,
    UtCardContentDirective,
    TranslatePipe,
  ],
})
export class AccountActionsComponent {
  @Input() pageTitle: string;
  @Input() imageUuid: string;
}
